import {
  Navigate,
  RouterProvider,
  createBrowserRouter
} from "react-router-dom";
import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import PageWrapper from "../components/PageWrapper";
import KhatabatClients from "./khattabat/KhatabatClients";
import KhattabatSearchingAnd101M from "./khattabat/matching/search-and-101m";
import KhattabatResults from "./khattabat/matching/results";
import KhattabatNewClients from "./khattabat/new-clients";
import Login from "./login";
import ChangePassword from "./csr/change-password";
import UserAdvanced from "./user/user-advanced";
import UserEvents from "./user/user-events";
import UserMessages from "./user/user-messages";
import UserPayments from "./user/user-payments";

// This admin client is dedicated to Al-Khattaba (matchmaker) users only.
// Every signed-in user is a khattaba admin, so the routing table contains
// only the khattaba experience plus the shared user-data pages the
// matchmaker needs. Non-khattaba (CSR / Auditor / Supervisor / Developer /
// QA / Communications / Shareholder) routes have been removed.
const RouterComponent = observer(() => {
  const router = useMemo(() => {
    const routes = [
      {
        path: "/",
        element: <PageWrapper isBlocker={false} Page={Login} />
      },
      {
        path: "/users/advanced",
        element: <PageWrapper isBlocker={false} Page={UserAdvanced} />
      },
      {
        path: "/users/events",
        element: <PageWrapper isBlocker={false} Page={UserEvents} />
      },
      {
        path: "/users/messages",
        element: <PageWrapper isBlocker={false} Page={UserMessages} />
      },
      {
        path: "/users/payments",
        element: <PageWrapper isBlocker={false} Page={UserPayments} />
      },
      {
        path: "/csr/changePassword",
        element: <PageWrapper isBlocker={false} Page={ChangePassword} />
      },
      {
        path: "/khattabat/:gender",
        element: <PageWrapper isBlocker={false} Page={KhatabatClients} />
      },
      {
        path: "/khattabat/newClients",
        element: <PageWrapper isBlocker={false} Page={KhattabatNewClients} />
      },
      {
        path: "/khattabatMatching/searchAnd1O1M",
        element: (
          <PageWrapper isBlocker={false} Page={KhattabatSearchingAnd101M} />
        )
      },
      {
        path: "/khattabatMatching/results",
        element: <PageWrapper isBlocker={false} Page={KhattabatResults} />
      },
      {
        path: "*",
        element: <Navigate to="/" replace />
      }
    ];

    return createBrowserRouter(routes);
  }, []);

  return <RouterProvider router={router} />;
});

export default RouterComponent;
